module.exports = __webpack_public_path__ + "static/media/ARROZCE_MENU-normal.29e82484.png";